import React from "react";
import { CheckCircle2, Clock3 } from "lucide-react";
import type { AssinaturaTvSetor } from "../../../../services/controleProducaoService";

export function formatarHorarioAssinatura(iso?: string | null): string {
  if (!iso) return "";
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatarResponsaveis(nomes: string[]): string {
  if (nomes.length === 0) return "Aguardando";
  if (nomes.length <= 2) return `Aguardando: ${nomes.join(", ")}`;
  return `Aguardando: ${nomes.slice(0, 2).join(", ")} e +${nomes.length - 2}`;
}

export const AssinaturaLinha: React.FC<{
  label: string;
  assinatura: AssinaturaTvSetor;
  compact?: boolean;
}> = ({ label, assinatura, compact }) => {
  const horario = formatarHorarioAssinatura(assinatura.data);
  const papel = assinatura.papel?.trim() || null;
  const responsaveis = (assinatura.responsaveis ?? []).filter((n) =>
    n.trim(),
  );
  return (
    <div className={compact ? "min-w-0" : "mt-3 min-w-0"}>
      <p
        className={`font-black uppercase tracking-[0.12em] ${
          compact ? "text-[10px] sm:text-xs" : "text-xs sm:text-sm"
        }`}
      >
        {label}
      </p>
      {papel ? (
        <p
          className={`mt-0.5 font-semibold uppercase tracking-wide text-yellow-200/90 ${
            compact ? "text-[10px] sm:text-xs" : "text-xs sm:text-sm"
          }`}
        >
          Quem assina: {papel}
        </p>
      ) : null}
      {assinatura.assinado ? (
        <p
          className={`mt-0.5 flex items-center gap-1.5 font-bold text-emerald-300 ${
            compact ? "text-sm sm:text-base" : "text-base sm:text-lg"
          }`}
        >
          <CheckCircle2 className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" />
          <span className="min-w-0 truncate">
            {[assinatura.nome, horario].filter(Boolean).join(" · ") ||
              "Assinado"}
          </span>
        </p>
      ) : (
        <p
          className={`mt-0.5 flex items-center gap-1.5 font-bold text-amber-300 ${
            compact ? "text-sm sm:text-base" : "text-base sm:text-lg"
          }`}
        >
          <Clock3 className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" />
          <span className="min-w-0 truncate">
            {formatarResponsaveis(responsaveis)}
          </span>
        </p>
      )}
    </div>
  );
};
